import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LoaderWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  font-size: 2em;
  height: 100%;
`;

const LoadingText = styled.p`
  font-size: large;
`;

interface ILoaderProps {
  text?: string;
  failed?: boolean;
  failedText?: string;
}

export class Loader extends React.Component<ILoaderProps> {
  public render() {
    if (this.props.failed === true) {
      return (
        <LoaderWrapper direction={FlexDirection.column} style={{ color: 'red' }}>
          <FontAwesomeIcon icon="times" />
          <LoadingText>{this.props.failedText ? this.props.failedText : 'Error'}</LoadingText>
        </LoaderWrapper>
      );
    } else {
      return (
        <LoaderWrapper direction={FlexDirection.column}>
          <FontAwesomeIcon icon="circle-notch" className="fa-spin" />
          <LoadingText>{this.props.text ? this.props.text : 'Loading'}</LoadingText>
        </LoaderWrapper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.tsx